import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Switch } from '../../../components/ui/switch';
import { Button } from '../../../components/ui/button';
import { AlertTriangle, Save } from 'lucide-react';

export function SMSSettings({ data, setData, isSaving, onSave, IntegrationStatus }) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-bold text-slate-900 font-[Poppins]">SMS Notifications</h3>
          <p className="text-sm text-slate-500 mt-1">Send OTP and booking notifications</p>
        </div>
        <div className="flex items-center gap-3">
          <IntegrationStatus enabled={data.enabled} />
          <Switch
            checked={data.enabled}
            onCheckedChange={(checked) => setData(prev => ({ ...prev, enabled: checked }))}
            data-testid="sms-toggle"
          />
        </div>
      </div>
      
      <div className="space-y-4">
        <div>
          <Label>Provider</Label>
          <select
            value={data.provider}
            onChange={(e) => setData(prev => ({ ...prev, provider: e.target.value }))}
            className="w-full h-12 mt-1.5 border border-stone-200 rounded-lg px-3"
            data-testid="sms-provider"
          >
            <option value="twilio">Twilio (International)</option>
            <option value="semaphore">Semaphore (Philippines)</option>
            <option value="vonage">Vonage</option>
          </select>
        </div>
        
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label>{data.provider === 'twilio' ? 'Account SID' : 'API Key'}</Label>
            <Input
              placeholder="Your API key"
              value={data.api_key}
              onChange={(e) => setData(prev => ({ ...prev, api_key: e.target.value }))}
              className="h-12 mt-1.5"
              data-testid="sms-api-key"
            />
          </div>
          {data.provider === 'twilio' && (
            <div>
              <Label>Auth Token</Label>
              <Input
                type="password"
                placeholder="Your auth token"
                value={data.api_secret}
                onChange={(e) => setData(prev => ({ ...prev, api_secret: e.target.value }))}
                className="h-12 mt-1.5"
                data-testid="sms-api-secret"
              />
            </div>
          )}
        </div>
        
        <div>
          <Label>Sender ID / Phone Number</Label>
          <Input
            placeholder={data.provider === 'twilio' ? '+1234567890' : 'HANDYBAYANI'}
            value={data.sender_id}
            onChange={(e) => setData(prev => ({ ...prev, sender_id: e.target.value }))}
            className="h-12 mt-1.5"
            data-testid="sms-sender"
          />
        </div>
      </div>
      
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mt-4">
        <div className="flex gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-amber-800 font-medium">OTP Authentication</p>
            <p className="text-sm text-amber-700 mt-1">
              SMS is currently mocked for demo. Enable real SMS to activate OTP authentication.
            </p>
          </div>
        </div>
      </div>
      
      <Button 
        onClick={onSave}
        disabled={isSaving}
        className="mt-6 bg-slate-900 hover:bg-slate-800"
        data-testid="save-sms-btn"
      >
        <Save className="w-4 h-4 mr-2" />
        {isSaving ? 'Saving...' : 'Save SMS Settings'}
      </Button>
    </div>
  );
}
